<template>
    <div class="qingwu">
        <div class="admin_main_block">
            <div class="admin_main_block_top">
                <div class="admin_main_block_left">
                    <div>推送消息设置</div>
                </div>

                <div class="admin_main_block_right">
                    <div><el-button icon="el-icon-back" @click="$router.go(-1)">返回</el-button></div>
                </div>
            </div>

            <div class="admin_form_main">
                <el-form  label-width="100px" ref="info" :model="info">
                    <el-form-item label="会议时间" prop="F_VR_HUIYSJ" :rules="[{required:true,message:'会议时间不能为空',trigger: 'blur' }]"><el-input type="textarea" placeholder="请输入会议时间" maxlength="200" show-word-limit v-model="info.F_VR_HUIYSJ"></el-input></el-form-item>
                    <el-form-item label="会议主题" prop="F_VR_HUIYZT" :rules="[{required:true,message:'会议主题不能为空',trigger: 'blur' }]"><el-input type="textarea" placeholder="请输入会议主题" maxlength="200" show-word-limit v-model="info.F_VR_HUIYZT"></el-input></el-form-item>
                    <el-form-item label="会议地址" prop="F_VR_HUIYDD" :rules="[{required:true,message:'会议地址不能为空',trigger: 'blur' }]"><el-input type="textarea" placeholder="请输入会议地址" maxlength="200" show-word-limit v-model="info.F_VR_HUIYDD"></el-input></el-form-item>
                    <el-form-item label="会议备注" prop="F_VR_BEIZ" :rules="[{required:true,message:'会议备注不能为空',trigger: 'blur' }]"><el-input type="textarea" placeholder="请输入会议备注" maxlength="200" show-word-limit v-model="info.F_VR_BEIZ"></el-input></el-form-item>

                    <el-form-item>
                        <el-button type="primary" @click="submitForm('info')">提交</el-button>
                        <!-- <el-button @click="resetForm('info')">重置</el-button> -->
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
      return {
          edit_id:0,
          info:{
          },
          list:[],
          upload_headers:{},
      };
    },
    watch: {},
    computed: {},
    methods: {
        resetForm:function(e){
            this.$refs[e].resetFields();
        },
        submitForm:function(e){
            let _this = this;

            // 验证表单
            this.$refs[e].validate(function(res){
                if(res){
                    //  判断是Add 或者 Edit
                    let url = _this.$api.addXxts;
                    if(_this.edit_id>0){
                        url = _this.$api.editXxts+_this.edit_id;
                    }
                    // Http 请求
                    _this.$post(url,_this.info).then(function(res){
                        if(res.code == 200){
                            _this.$message.success("编辑成功");
                            _this.$router.go(-1);
                        }else{
                            _this.$message.error("编辑失败");
                        }
                    });
                }
            });
        },
        get_adv_info:function(){
            let _this = this;
            this.$get(this.$api.editXxts+this.edit_id).then(function(res){
                _this.info = res.data.xianslb;
                _this.list = res.data.zsls;
            })

        },

        selectChange:function(){
            this.$forceUpdate();
        },
        handleAvatarSuccess(res) {
            this.info.adv_image = res.data;
            this.$forceUpdate();
        },
    },
    created() {
        this.upload_headers.Authorization = 'Bearer '+localStorage.getItem('token'); // 要保证取到

        if(!this.$isEmpty(this.$route.params.adv_position_id)){
            this.info.ap_id = this.$route.params.adv_position_id;
        }

        // 判断是否是编辑
        if(!this.$isEmpty(this.$route.params.id)){
            this.edit_id = this.$route.params.id;
        }

        if(this.edit_id>0){
            this.get_adv_info();
        }
        
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>
.line{text-align: center}
</style>